<template>
  <div
    v-if="
      $route.name !== 'pricing' && $route.name !== 'pricing-slug' && !isAlumni
    "
    class="sideblock-container"
  >
    <div
      v-for="plan in plansDueForRenewal"
      :key="plan.id"
      class="block block--sideblock renewal"
    >
      <h2>Don't lose access!</h2>
      <p v-if="isPlanActive(plan.pivot.valid_to)">
        Your current <strong>{{ plan.label }}</strong> plan is going to expire
        on {{ formatDate(plan.pivot.valid_to) }}, renew now at a reduced rate to
        continue accessing content.
      </p>
      <p v-else>
        Your current <strong>{{ plan.label }}</strong> expired on
        {{ formatDate(plan.pivot.valid_to) }}, you have until
        {{ renewalDeadline(plan.pivot.valid_to, plan.renewal_days_after) }} to
        renew at a reduced rate and continue to have access to all our content.
      </p>
      <NuxtLink class="btn btn--primary btn--small" :to="{ path: `/pricing` }"
        >Renew Access</NuxtLink
      >
    </div>
  </div>
</template>

<script setup lang="ts">
  import moment from "moment";

  const userStore = useUserStore();

  const currentUser = computed(() => userStore.getCurrentUser);
  const isAlumni = computed(() => {
    return currentUser.value?.is_alumni ?? false;
  });
  const userPlans = computed(() => userStore.getUserPlans);

  const plansDueForRenewal = computed(() => {
    return userPlans.value.filter(plan => {
      return (
        plan.type !== "free" &&
        isUserInRenewalState(
          plan.renewal_days_before,
          plan.renewal_days_after,
          plan.pivot.valid_to
        )
      );
    });
  });

  function isPlanActive(validTo: string): boolean {
    return moment(validTo).isAfter(moment());
  }

  function formatDate(date: string): string {
    return moment(date).format("Do MMMM YYYY");
  }

  function renewalDeadline(validTo: string, renewalDaysAfter: number): string {
    return moment(validTo).add(renewalDaysAfter, "days").format("Do MMMM YYYY");
  }
</script>

<style lang="scss" scoped>
  .renewal {
    border: 5px dashed $pforange;
    color: $pfgreen;

    h2 {
      color: $pfgreen;
    }
  }
</style>
